module.exports = __webpack_public_path__ + "img/game02.b9c54e9f.jpg";